import React from 'react'
import error404 from '../../assets/images/errorImg.png'
import { Link } from 'react-router-dom'
const ErrorPage = () => {
    return (
        <>
            <div className="maintenance-block">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card error-card">
                                <div className="card-body">
                                    <div className="error-image-block">
                                        <img
                                            className="img-fluid"
                                            src={error404}
                                            height={100}
                                            style={{ background: 0 ,height:"500px"}}
                                            alt="img"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <p className="mt-2 mb-4 text-muted">
                                            The page you are looking was moved, removed,
                                            <br /> renamed, or might never exist!
                                        </p>
                                        <Link to="/login" className="btn btn-success mb-3">
                                            Go to home
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ErrorPage